<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, onBeforeMount } from 'vue';
import {initAppStore} from "@/store/init";

const setViewportHeight = (): void => {
  const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

onMounted(() => {
  setViewportHeight();
  window.addEventListener('resize', setViewportHeight);
});
onBeforeMount(async () => {
  await initAppStore()
})

onBeforeUnmount( () => {
  window.removeEventListener('resize', setViewportHeight);

});
</script>

<style lang="scss">
:root {
  --vh: 100vh;
}

#app {
  overflow-x: hidden;
}
</style>